var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-background" },
    [
      _c("smart-back-button", { attrs: { backToLabel: "Back to Shipments" } }),
      _c(
        "v-row",
        { staticClass: "px-16 mb-12 mt-n10", attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pl-0", attrs: { cols: "auto" } },
                    [
                      _c("label", { staticClass: "page-header" }, [
                        _vm._v("Saved Queries"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-6" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pl-0",
                      attrs: { xl: "6", lg: "7", md: "9" },
                    },
                    [
                      _c("saved-query-filters", {
                        on: {
                          run: _vm.run,
                          openEmailResultsDialog: _vm.openEmailResultsDialog,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.currentReportData.length
                ? _c(
                    "v-row",
                    { staticClass: "mt-6" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "users-grid-wrapper pl-3 br-10" },
                            [_c("v-card-text", [_c("saved-query-results")], 1)],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-overlay",
                {
                  attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-n16" },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "text-center",
                          class: { "px-6": _vm.smAndDown },
                        },
                        [
                          _c("img", {
                            staticClass: "rotating",
                            attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                          }),
                          _c("p", { staticClass: "overlay-txt mt-5" }, [
                            _vm._v(_vm._s(_vm.loadingMessage)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pagingLength > 1
                ? _c(
                    "v-row",
                    { staticClass: "mt-6", attrs: { justify: "center" } },
                    [
                      _c(
                        "v-col",
                        { staticClass: "pl-0", attrs: { cols: "auto" } },
                        [
                          _c("v-pagination", {
                            staticClass: "pl-3",
                            attrs: {
                              length: _vm.pagingLength,
                              "total-visible": "10",
                            },
                            on: { input: _vm.pageChange },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-dialog",
                {
                  attrs: { "max-width": "600px", scrollable: "", eager: "" },
                  model: {
                    value: _vm.showEmailResultsDialog,
                    callback: function ($$v) {
                      _vm.showEmailResultsDialog = $$v
                    },
                    expression: "showEmailResultsDialog",
                  },
                },
                [
                  _vm.showEmailResultsDialog
                    ? _c("send-query-results", {
                        on: {
                          close: function ($event) {
                            _vm.showEmailResultsDialog = false
                          },
                          sendEmail: _vm.sendEmail,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }